import React, { useState } from "react";
import InputField from "./utility-components/InputField";
import { useParams } from "react-router-dom";

function Form({ addAttendee, eventId }) {
  const { referal } = useParams();

  const [attendee, setAttendee] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    location: "",
    about_event: "",
    reason: "",
    referal: referal ? referal : "",
  });

  const handleChange = (e) => {
    setAttendee({ ...attendee, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      first_name: attendee.firstName,
      last_name: attendee.lastName,
      email: attendee.email,
      phone_number: attendee.phoneNumber,
      location: attendee.location,
      referal: attendee.referal,
      about_event: attendee.about_event,
      reason: attendee.reason,
      event: eventId,
    };
    addAttendee(payload);
    setAttendee({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      location: "",
      referal: "",
    });
  };
  return (
    <form onSubmit={handleSubmit} className="mt-14 w-full h-full">
      {/* name */}
      <div className="flex flex-col gap-1 mt-8">
        <h3 className="text-lg">
          Name <span>*</span>
        </h3>
        <div className="flex gap-2 w-full">
          <InputField
            handleChange={handleChange}
            value={attendee.firstName}
            name="firstName"
            id="first_name"
            type="text"
            width="w-full"
            height="h-14"
            label="First Name"
            required={true}
            disabled={false}
          />
          <InputField
            handleChange={handleChange}
            value={attendee.lastName}
            name="lastName"
            id="last_name"
            type="text"
            width="w-full"
            height="h-14"
            label="Last Name"
            required={true}
            disabled={false}
          />
        </div>
      </div>
      {/* Email */}
      <div className="flex flex-col gap-1 mt-8">
        <h3 className="text-lg">
          Email <span>*</span>
        </h3>
        <InputField
          handleChange={handleChange}
          value={attendee.email}
          name="email"
          id="email"
          type="email"
          width="w-full"
          height="h-14"
          label="example@mail.com"
          required={true}
          disabled={false}
        />
      </div>
      {/* phone number */}
      <div className="flex flex-col gap-1 mt-8">
        <h3 className="text-lg">
          Phone Number <span>*</span>
        </h3>
        <InputField
          handleChange={handleChange}
          value={attendee.phoneNumber}
          name="phoneNumber"
          id="phone_number"
          type="tel"
          width="w-full"
          height="h-14"
          label="08123456789"
          required={true}
          disabled={false}
        />
      </div>
      {/* how did you get to know about event */}
      <div className="flex flex-col gap-1 mt-8">
        <h3 className="text-lg">
          How did you get to know about this event? <span>*</span>
        </h3>
        <InputField
          handleChange={handleChange}
          value={attendee.about_event}
          name="about_event"
          id="about_event"
          type="text"
          width="w-full"
          height="h-14"
          label="facebook, instagram, billboard, radio, etc"
          required={true}
          disabled={false}
        />
      </div>
      {/* reasons for attending */}
      <div className="flex flex-col gap-1 mt-8">
        <h3 className="text-lg">
          What is your reason for attending? <span>*</span>
        </h3>
        <InputField
          handleChange={handleChange}
          value={attendee.reason}
          name="reason"
          id="reason"
          type="text"
          width="w-full"
          height="h-14"
          label="Investment purpose, Business Education, Become an Associate, etc"
          required={true}
          disabled={false}
        />
      </div>
      {/* Referal */}
      <div className="flex flex-col gap-1 mt-8">
        <h3 className="text-lg">Referal</h3>
        <InputField
          handleChange={handleChange}
          value={attendee.referal}
          name="referal"
          id="referal"
          type="text"
          width="w-full"
          height="h-14"
          label="Referal"
          required={false}
          disabled={referal ? true : false}
        />
      </div>
      {/* location */}
      <div className="flex flex-col gap-1 mt-8">
        <h3 className="text-lg">
          Location <span>*</span>
        </h3>
        <InputField
          handleChange={handleChange}
          value={attendee.location}
          name="location"
          id="location"
          type="text"
          width="w-full"
          height="h-14"
          label="Location"
          required={false}
          disabled={false}
        />
      </div>

      <button
        type="submit"
        className="bg-green-50 hover:bg-opacity-80 text-white text-lg  w-full h-14 p-2 flex items-center justify-center mt-12 rounded-lg capitalize"
      >
        Submit
      </button>
    </form>
  );
}

export default Form;
